import * as Sentry from "@sentry/vue";

let isLocal = false;
type ErrorConstructorWithCaptureStackTrace = ErrorConstructor & {
  captureStackTrace?: (targetObject: object, constructorOpt?: (...args: unknown[]) => unknown) => void;
};

export const initExceptionClient = (isLocalEnv: boolean) => {
  isLocal = isLocalEnv;
};

export const setSentryUser: typeof Sentry.setUser = (user) => {
  if (!isLocal) {
    Sentry.setUser(user);
  }
};

export const printOrCaptureException = (ex: unknown, extras?: Record<string, unknown>): void => {
  if (isLocal) {
    // eslint-disable-next-line no-console
    console.error(ex);
    if (extras) {
      // eslint-disable-next-line no-console
      console.error(extras);
    }
  } else {
    Sentry.captureException(ex, extras ? { extra: extras } : undefined);
  }
};

export const printOrCaptureMessage = (msg: string, extras?: Record<string, unknown>): void => {
  if (isLocal) {
    // eslint-disable-next-line no-console
    console.warn(msg);
    if (extras) {
      // eslint-disable-next-line no-console
      console.warn(extras);
    }
  } else {
    const ex = new Error(msg);
    // Keep stack traces anchored to the callsite instead of this helper
    (Error as ErrorConstructorWithCaptureStackTrace).captureStackTrace?.(ex, printOrCaptureMessage);
    Sentry.captureException(ex, { extra: extras, level: "warning" });
  }
};

const removeErrorPrefix = (value: string | undefined): string | undefined => {
  if (!value) {
    return value;
  }

  let normalizedValue = value;
  while (normalizedValue.startsWith("Error: ")) {
    normalizedValue = normalizedValue.slice(7);
  }
  return normalizedValue;
};

export const normalizeSentryEvent = (event: Sentry.ErrorEvent, release: string | undefined): Sentry.ErrorEvent => ({
  ...event,
  release,
  message: removeErrorPrefix(event.message),
  logentry: event.logentry
    ? {
        ...event.logentry,
        message: removeErrorPrefix(event.logentry.message),
      }
    : event.logentry,
  exception: event.exception
    ? {
        ...event.exception,
        values: event.exception.values?.map((exception) => ({
          ...exception,
          value: removeErrorPrefix(exception.value),
          type: exception.type === "Error" ? undefined : exception.type,
        })),
      }
    : event.exception,
});
